import AbstractDropdownButton from '../../../controls/abstract_dropdown_button'
import Ext from 'Ext'
import NumberFormatter from '../../../number_formatter'
import {isLeaveRatesEmpty} from '../../../panels/user/accountSettings/userRates/validationUtils'

const numberFormatter = new NumberFormatter(
    window.SystemSettings.decimalSeparator, null,
    4, false, undefined, undefined, undefined, 2)

const LeaveRatesEditor = Ext.extend(AbstractDropdownButton, {

    value: null,

    initComponent: function()
    {
        this.cls = "at-dropdown-list-btn";
        this.ctCls = "at-dropdown-list-btn-ct";

        LeaveRatesEditor.superclass.initComponent.call(this);

        this.addEvents("change");
    },

    showMenu: function()
    {
        this.menu.setActivatedButton( this );
        return LeaveRatesEditor.superclass.showMenu.call( this );
    },

    onOk: function()
    {
        this.menu.hide();
    },

    onCancel: function()
    {
        this.menu.hide();
    },

    onMenuShow: function( menu )
    {
        if( this.menu.getActivatedButton() === this )
            LeaveRatesEditor.superclass.onMenuShow.call( this, menu );
    },

    onMenuHide: function(  menu )
    {
        if( this.menu.getActivatedButton() === this )
        {
            LeaveRatesEditor.superclass.onMenuHide.call( this, menu );
            this.menu.setActivatedButton( null );
            if( !this.menu.wasCanceled() )
            {
                var oldValue = this.value;
                this.value = this.menu.getLeaveRates();
                if( !this.areEqual( this.value, oldValue ) )
                    this.fireEvent("change", this.value);
            }
        }
    },

    areEqual: function(leaveRates1, leaveRates2)
    {
        if ( leaveRates1 == null || leaveRates2 == null )
            return leaveRates1 == leaveRates2;

        if(isLeaveRatesEmpty(leaveRates1) && isLeaveRatesEmpty(leaveRates2))
            return true;

        for( var i1 = 0; i1 < leaveRates1.length; i1++ )
        {
            var lr1 = leaveRates1[i1];
            var lr2 = null;
            for( var i2 = 0; i2 < leaveRates2.length; i2++ )
            {
                if( leaveRates2[i2].leaveTypeId == lr1.leaveTypeId )
                {
                    lr2 = leaveRates2[i2];
                    break;
                }
            }

            if( !lr2 || numberFormatter.format(lr2.rate) !== numberFormatter.format(lr1.rate))
                return false;
        }

        return true;
    }
});

export default LeaveRatesEditor



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/ratesEditor/LeaveRatesEditor.js